// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/Font/Roboto/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div, table, td, tr, th {
    box-sizing: border-box !important;
}

@font-face {
    font-family: 'Roboto';
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('truetype');
    font-weight: 400;
    font-style: normal;
}





/* --------------------- UNDER TOSS PAYMENTS --------------------- */

.w-100 {
    width: 100%;
}

.h-100 {
    height: 100%;
}

a {
    text-decoration: none;
    text-align: center;
}

.wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 24px;
    overflow: auto;
}

.max-w-540 {
    max-width: 540px;
}

.btn-wrapper {
    padding: 0 24px;
}

.btn {
    padding: 11px 22px;
    border: none;
    border-radius:  8px;

    background-color: #f2f4f6;
    color: #4e5968;
    font-weight: 600;
    font-size: 17px;
    cursor: pointer;
}

.btn.primary {
    background-color: #3282f6;
    color: #f9fcff;
}

.text-center {
    text-align: center;
}

.flex {
    display: flex;
}

.flex-column {
    display: flex;
    flex-direction: column;
}

.justify-center {
    justify-content: center;
}

.justify-between {
    justify-content: space-between;
}

.align-center {
    align-items: center;
}

.confirm-loading {
    margin-top: 72px;
    height: 400px;
    justify-content: space-between;
}


.confirm-success {
    display: none;
    margin-top: 72px;
}

.button-group {
    margin-top: 32px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 16px;
}

.title {
    margin-top: 32px;
    margin-bottom: 0;
    color: #191f28;
    font-weight: bold;
    font-size: 24px;
}

.description {
    margin-top: 8px;
    color: #4e5968;
    font-size: 17px;
    font-weight: 500;
}

.response-section {
    margin-top: 60px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    font-size: 20px;
}

.response-section .response-label {
    font-weight: 600;
    color: #333d48;
    font-size: 17px;
}

.response-section .response-text {
    font-weight: 500;
    color: #4e5968;
    font-size: 17px;
    padding-left: 16px;
    word-break: break-word;
    text-align: right;
}

.color-grey {
    color: #b0b8c1;
}

.ant-message {
    z-index: 9999999 !important;
}

.popWrap {
    z-index: 99999999 !important;
}

.ant-picker-dropdown, .ant-select-dropdown, .ant-image-preview-wrap{
    z-index: 9999999 !important;
}


.slick-slider , .slick-list, .slick-track{
    height: 100%;
}

.slick-slide > div {
    width: 100%;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/globalStyles.css"],"names":[],"mappings":"AAAA;IACI,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,+DAAsE;IACtE,gBAAgB;IAChB,kBAAkB;AACtB;;;;;;AAMA,oEAAoE;;AAEpE;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;;IAEnB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;;AAGA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,2BAA2B;AAC/B;;;AAGA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB","sourcesContent":["div, table, td, tr, th {\n    box-sizing: border-box !important;\n}\n\n@font-face {\n    font-family: 'Roboto';\n    src: url('./assets/Font/Roboto/Roboto-Regular.ttf') format('truetype');\n    font-weight: 400;\n    font-style: normal;\n}\n\n\n\n\n\n/* --------------------- UNDER TOSS PAYMENTS --------------------- */\n\n.w-100 {\n    width: 100%;\n}\n\n.h-100 {\n    height: 100%;\n}\n\na {\n    text-decoration: none;\n    text-align: center;\n}\n\n.wrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding: 24px;\n    overflow: auto;\n}\n\n.max-w-540 {\n    max-width: 540px;\n}\n\n.btn-wrapper {\n    padding: 0 24px;\n}\n\n.btn {\n    padding: 11px 22px;\n    border: none;\n    border-radius:  8px;\n\n    background-color: #f2f4f6;\n    color: #4e5968;\n    font-weight: 600;\n    font-size: 17px;\n    cursor: pointer;\n}\n\n.btn.primary {\n    background-color: #3282f6;\n    color: #f9fcff;\n}\n\n.text-center {\n    text-align: center;\n}\n\n.flex {\n    display: flex;\n}\n\n.flex-column {\n    display: flex;\n    flex-direction: column;\n}\n\n.justify-center {\n    justify-content: center;\n}\n\n.justify-between {\n    justify-content: space-between;\n}\n\n.align-center {\n    align-items: center;\n}\n\n.confirm-loading {\n    margin-top: 72px;\n    height: 400px;\n    justify-content: space-between;\n}\n\n\n.confirm-success {\n    display: none;\n    margin-top: 72px;\n}\n\n.button-group {\n    margin-top: 32px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 16px;\n}\n\n.title {\n    margin-top: 32px;\n    margin-bottom: 0;\n    color: #191f28;\n    font-weight: bold;\n    font-size: 24px;\n}\n\n.description {\n    margin-top: 8px;\n    color: #4e5968;\n    font-size: 17px;\n    font-weight: 500;\n}\n\n.response-section {\n    margin-top: 60px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    font-size: 20px;\n}\n\n.response-section .response-label {\n    font-weight: 600;\n    color: #333d48;\n    font-size: 17px;\n}\n\n.response-section .response-text {\n    font-weight: 500;\n    color: #4e5968;\n    font-size: 17px;\n    padding-left: 16px;\n    word-break: break-word;\n    text-align: right;\n}\n\n.color-grey {\n    color: #b0b8c1;\n}\n\n.ant-message {\n    z-index: 9999999 !important;\n}\n\n.popWrap {\n    z-index: 99999999 !important;\n}\n\n.ant-picker-dropdown, .ant-select-dropdown, .ant-image-preview-wrap{\n    z-index: 9999999 !important;\n}\n\n\n.slick-slider , .slick-list, .slick-track{\n    height: 100%;\n}\n\n.slick-slide > div {\n    width: 100%;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
